import React from "react";
import Footer from "../../components/common/Footer";
import Header from "../../components/common/Header";
import PrivacyPolicyJSX from "../../components/Legal/privacy-policy";
const LegalPP = () => {
  return (
    <>
      <Header />
      <div className="container p-5">
        <PrivacyPolicyJSX />
      </div>
      <Footer />
    </>
  );
};

export default LegalPP;
